import React, { useState, useEffect } from "react";
import { getElementPath } from "./../../helpers/dom";
import SearchResult from "./SearchResult";

export default function Search({sm}) {
    let [dropdown, setDropdown] = useState("all");
    let [searchInput, setSearchInput] = useState("");
    let [searchTimeout, setSearchTimeout] = useState();
    let [resultVisible, setResultVisible] = useState(false);
    let [data, setData] = useState({});

	useEffect(() => {
		if (searchInput.length < 2) return;
		const timeout = setTimeout(() => 
			window.Dibook.search.fetchSearch(dropdown, searchInput).then(result => setData(result))
		, 300);

		if(searchTimeout)
			clearTimeout(searchTimeout)

		setSearchTimeout(timeout)
	}, [searchInput, dropdown]);

	// Result visibility functions
	useEffect(() => {
		searchInput.length > 1 ? setResultVisible(true) : setResultVisible(false);
	}, [searchInput]);

	useEffect(() => {
		document.getElementById("subnav").className =  resultVisible ? "subnav d-none" : "subnav";
	}, [resultVisible]);

	// Global click
	useEffect(() => {
		document.addEventListener("click", handleGlobalClick);

		return () => {
			document.removeEventListener("click", handleGlobalClick);
		};
	}, []);

	function handleGlobalClick(e) {
		let pathArray = getElementPath(e.target);

		if (!pathArray.some(elem => /widget-search/g.test(elem))) {
			setResultVisible(false);
		}
	}

    return (
		<>
			<div className="input">
				<input
					type="text"
					className={"form-control" + (!sm ? " w-100" : '')}
					style={{minWidth: 120}}
					placeholder="Keresés"
					value={searchInput}
					onChange={e => setSearchInput(e.target.value)}
					onFocus={handleSearchInputFocus}
					onKeyPress={handleSearchInputKeyPress}
				/>
				{searchInput.length > 1 && (
					<div className="reset" onClick={() => setSearchInput("")}></div>
				)}

				<button type="submit" onClick={handleSearchButtonClick} aria-label="Keresés"></button>
				<input type="hidden" name="q" value={searchInput} />
			</div>

			{resultVisible && (
				<SearchResult
					searchInput={searchInput}
					data={data}
					onResultClick={handleResultClick}
					onType={[dropdown, setDropdown]}
				/>
			)}
		</>
	);

	function handleSearchInputKeyPress(e) {
		if (searchInput.length > 1 && e.key === "Enter") {
			let baseUrl = getBaseUrl();
			window.location.href =
				baseUrl + "/kereses?" + dropdown + "=" + encodeURIComponent(searchInput);
		}
	}

    function handleSearchButtonClick() {
        if (searchInput.length > 1) {
            let baseUrl = getBaseUrl();

			window.Dibook.ping.search({
				searchString: searchInput
			});
			window.location.href =
				baseUrl + "/kereses?" + dropdown + "=" + encodeURIComponent(searchInput);
		}
	}

	function handleSearchInputFocus() {
		if (searchInput.length > 1) setResultVisible(true);
	}

	function getBaseUrl() {
		return window.location.protocol + "//" + window.location.host;
	}

	function handleResultClick() {
		window.Dibook.ping.search({
			searchString: searchInput
		});
	}
}
